<div class="modal-header">
    <h4 class="modal-title">
        {{ mode === formMode.EDIT ? 'Editar Modelo' : (mode === formMode.VIEW ? 'Ver Modelo' : 'Nuevo Modelo') }}
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <div class="mb-3">
            <label class="form-label">Marca</label>
            <ng-select [items]="brands" bindLabel="name" bindValue="code" formControlName="brandCode"
                placeholder="Seleccione Marca" (change)="refreshCode()"></ng-select>
        </div>

        <div class="row">
            <div class="col-md-6 mb-3">
                <label for="year" class="form-label">Año</label>
                <input type="number" id="year" class="form-control" formControlName="year" (input)="refreshCode()">
            </div>
            <div class="col-md-6 mb-3">
                <label for="vehicleType" class="form-label">Tipo Vehículo</label>
                <ng-select [items]="vehicleTypeData" bindLabel="type" bindValue="type" formControlName="vehicleType"
                    placeholder="Seleccione Tipo Vehículo">
                </ng-select>
            </div>
        </div>

        <div class="mb-3">
            <label for="code" class="form-label">Código</label>
            <input type="number" id="code" class="form-control" formControlName="code" readonly>
            @if (mode === formMode.CREATE) {
            <small class="text-muted">Se genera solo: marca + año + correlativo. Ej: 1 + 2026 + 01 → 1202601</small>
            }
        </div>

        <div class="mb-3">
            <label for="name" class="form-label">Nombre</label>
            <input type="text" id="name" class="form-control" formControlName="name">
        </div>

        <div class="mb-3 form-check">
            <input type="checkbox" class="form-check-input" id="isActive" formControlName="isActive">
            <label class="form-check-label" for="isActive">Activo</label>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close()">
        {{ mode === formMode.VIEW ? 'Cerrar' : 'Cancelar' }}
    </button>
    @if (mode !== formMode.VIEW) {
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="form.invalid">Guardar</button>
    }
</div>
